export { default as SortDescIcon } from './SortDescIcon';
